<template>
    <div v-editable="blok">
        <b-form-group
            :label="blok.label"
        >
            <div :key="index" v-for="(child,index) in blok.input"> 
                <component :blok="child" :is="child.component"></component>
            </div>
        </b-form-group>
    </div>
</template>
<script>

import { mapActions, mapState } from "vuex";

import ProfilePeople from './ProfilePeople.vue';
import ProfileMealPrefences from './ProfileMealPrefences.vue';
import ProfileShippingRun from './ProfileShippingRun.vue';
import ProfileName from './ProfileName.vue';
import ProfileEmail from './ProfileEmail.vue';
import ProfilePostcode from './ProfilePostcode.vue';

export default {
    name: 'profile-question',
    props: {
        blok: Object
    },
    computed: {
        ...mapState({
            user: state => state.profile.user
        })
    },
    components: {
        'profile-meal-preferences': ProfileMealPrefences,
        ProfilePeople,
        ProfileShippingRun,
        ProfileName,
        ProfilePostcode,
        ProfileEmail
    }
}
</script>
